import { LicenseInfo } from '@mui/x-license-pro';

const LICENSE_KEY =
    '600375e8aba9c32cc1d88de5ee8b98e5Tz01NTcwOSxFPTE3MDE5ODMzMzc2NjQsUz1wcm8sTE09cGVycGV0dWFsLEtWPTI=';

export const setupMUILicense = () => {
    LicenseInfo.setLicenseKey(LICENSE_KEY);
};
